import type { SupplierClassificationUpdateIn } from '@/api/suppliers';

/** Dropdown vocab for the editable supplier classification (INP-516).
 *  The `value`s are typed against the OpenAPI enum, so a stale/misspelled
 *  option is a tsc error rather than a 422 at runtime. Labels are
 *  practitioner-facing. */
type TaxClass = SupplierClassificationUpdateIn['tax_class'];
type RegulatoryClass = SupplierClassificationUpdateIn['regulatory_class'];

export const TAX_CLASS_OPTIONS: { value: TaxClass; label: string }[] = [
  { value: 'tax_inclusive', label: 'Tax inclusive' },
  { value: 'separately_states', label: 'Separately stated' },
  { value: 'simplified_registry', label: 'Simplified registry' },
  { value: 'non_resident', label: 'Non-resident' },
  { value: 'mixed_supply', label: 'Mixed supply' },
  { value: 'unknown', label: 'Unknown' },
];

export const REGULATORY_CLASS_OPTIONS: { value: RegulatoryClass; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'securities_dealer', label: 'Securities dealer' },
  { value: 'securities_regulator', label: 'Securities regulator' },
  { value: 'crown_corp', label: 'Crown corporation' },
  { value: 'bank', label: 'Bank' },
  { value: 'insurance_admin', label: 'Insurance administrator' },
];

/** Canadian province/territory codes + a blank for "unknown". */
export const PROVINCE_OPTIONS: string[] = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'NT',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
];
